import Breadcrumb from './Breadcrumb';

export { default as BreadcrumbItem } from './BreadcrumbItem';

export default Breadcrumb;
